import { render, staticRenderFns } from "./CourseViewMassProgress.vue?vue&type=template&id=388855f6&"
import script from "./CourseViewMassProgress.vue?vue&type=script&lang=js&"
export * from "./CourseViewMassProgress.vue?vue&type=script&lang=js&"
import style0 from "./CourseViewMassProgress.vue?vue&type=style&index=0&id=388855f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports